export default __webpack_public_path__ + "static/media/votes_icon.32052cb9.svg";